
define('template!trackingTabTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div>\n\t<div class="well caccount-font-container jq-grid-table-page">\n\t\t<!-- <span class="loading-message js-loading-message label label-primary"></span> -->\n\t\t<div class="loading-block js-loading-block">\n\t\t\t<span class="loading-message js-loading-message label"></span>\n\t\t</div>\n\t\t<div class="vectorization-table">\n            <div class="form-group add-new-block">\n                <div class="btn js-add-tracking add-btn-text">\n                    <i class="mdi-content-add icon"></i>\n                    <span>' +
((__t = ( _.i18n('common.new') )) == null ? '' : __t) +
'</span>\n                </div>\n            </div>\n\t\t\t<table id="jq-grid-fonts" class="vectorTable" role="grid"></table>\n\t\t\t<div id="jq-grid-pager-fonts"></div>\n\t\t</div>\n\t</div>\n</div>\n';

}
return __p
};});

